/**
 * The operator-facing label of a report's workflow `state` (or the list
 * filter's `all`). One definition for the list's status filter, its cards and
 * the CSV export, so the file says what the screen says.
 *
 * The list endpoint sends the database spelling (`in progress`, `on hold`);
 * the underscore spelling is accepted too, so a caller holding a Prisma enum
 * name gets the same label rather than the raw value.
 */
export const issueReportStateLabel = (state: string, t: (key: string) => string): string => {
    switch ((state ?? '').toLowerCase().replace(/_/g, ' ')) {
        case 'all':
            return t('issue_reports.archive.status_all');
        case 'open':
            return t('issue_reports.card.open');
        case 'in progress':
            return t('issue_reports.card.in_progress');
        case 'on hold':
            return t('issue_reports.card.on_hold');
        case 'done':
            return t('issue_reports.card.resolved');
        default:
            return state;
    }
};
